import { isPlatformBrowser } from 'src/lib/isPlatformBrowser';

const apiUrl = process.env.GATSBY_API_URL;
const environmentName = process.env.GATSBY_APP_ENVIRONMENT_NAME;
const gtmMeasurementId = process.env.GATSBY_GTM_MEASUREMENT_ID;
const companyConfirmationExpirationMonths =
  process.env.GATSBY_COMPANY_CONFIRMATION_EXPIRATION_MONTHS || '3';

export const environment = {
  apiUrl,
  companyConfirmationExpirationMonths,
  environmentName,
  gtmMeasurementId,
} as const;

export const prependApiUrl =
  environmentName === 'production'
    ? (_: string) => _
    : (_: string) => (_.startsWith('http') ? _ : apiUrl + _);

if (isPlatformBrowser()) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.version = {
    version: process.env.GATSBY_APP_VERSION,
    environmentName: process.env.GATSBY_APP_ENVIRONMENT_NAME,
  };
}
